import { render, staticRenderFns } from "./lang.vue?vue&type=template&id=708c398e&scoped=true"
import script from "./lang.vue?vue&type=script&lang=js"
export * from "./lang.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708c398e",
  null
  
)

export default component.exports